/**
 * Tiered price display helpers.
 * A tier with unitQuantity === 0 is the open-ended “last” band: show as "> N Units"
 * where N is the largest positive unitQuantity among all tiers.
 */

/** API / table rows: tiers with unitQuantity === 0 always last (stable among equals). */
export function sortTierRowsOpenEndedLast(tierRows) {
  if (!Array.isArray(tierRows) || tierRows.length === 0) return tierRows;
  return [...tierRows].map((t, i) => ({
    t,
    i
  })).sort((a, b) => {
    var _a$t$unitQuantity, _a$t, _b$t$unitQuantity, _b$t;
    const az = Number((_a$t$unitQuantity = (_a$t = a.t) === null || _a$t === void 0 ? void 0 : _a$t.unitQuantity) !== null && _a$t$unitQuantity !== void 0 ? _a$t$unitQuantity : 0) === 0 ? 1 : 0;
    const bz = Number((_b$t$unitQuantity = (_b$t = b.t) === null || _b$t === void 0 ? void 0 : _b$t.unitQuantity) !== null && _b$t$unitQuantity !== void 0 ? _b$t$unitQuantity : 0) === 0 ? 1 : 0;
    if (az !== bz) return az - bz;
    return a.i - b.i;
  }).map(x => x.t);
}
export function maxPositiveTierUnitQuantity(tierRows) {
  if (!Array.isArray(tierRows) || tierRows.length === 0) return 0;
  const nums = tierRows.map(t => {
    var _t$unitQuantity;
    return Number((_t$unitQuantity = t === null || t === void 0 ? void 0 : t.unitQuantity) !== null && _t$unitQuantity !== void 0 ? _t$unitQuantity : 0);
  }).filter(q => Number.isFinite(q) && q > 0);
  return nums.length ? Math.max(...nums) : 0;
}

/**
 * @param {Array<{ unitQuantity?: number }>} tierRows
 * @param {number} index
 * @returns {string} e.g. "1-50 Units", "> 50 Units"
 */
export function getTieredPriceRowLabel(tierRows, index) {
  var _tierRows$index$unitQ, _tierRows$index, _tierRows$unitQuantit, _tierRows;
  if (!(tierRows !== null && tierRows !== void 0 && tierRows.length) || index < 0 || index >= tierRows.length) return '';
  const uq = Number((_tierRows$index$unitQ = (_tierRows$index = tierRows[index]) === null || _tierRows$index === void 0 ? void 0 : _tierRows$index.unitQuantity) !== null && _tierRows$index$unitQ !== void 0 ? _tierRows$index$unitQ : 0);
  if (uq === 0) {
    return "> ".concat(maxPositiveTierUnitQuantity(tierRows), " Units");
  }
  const prevUpper = index === 0 ? 0 : Number((_tierRows$unitQuantit = (_tierRows = tierRows[index - 1]) === null || _tierRows === void 0 ? void 0 : _tierRows.unitQuantity) !== null && _tierRows$unitQuantit !== void 0 ? _tierRows$unitQuantit : 0);
  const isLast = index === tierRows.length - 1;
  const hasOpenEndedTier = tierRows.some(t => {
    var _t$unitQuantity2;
    return Number((_t$unitQuantity2 = t === null || t === void 0 ? void 0 : t.unitQuantity) !== null && _t$unitQuantity2 !== void 0 ? _t$unitQuantity2 : 0) === 0;
  });
  if (isLast && !hasOpenEndedTier) {
    return "> ".concat(uq, " Units");
  }
  return "".concat(prevUpper + 1, "-").concat(uq, " Units");
}